import { CustomElement, OverrideCustomElementConfig } from "@cervval.js/client-html5-core/src/components/customElement.decorator";
import { TypedWebComponentOptions, WebComponentOptions } from "@cervval.js/client-html5-core/src/components/typedWebComponentOptions.decorator";
import { UID } from "@cervval.js/common-action/src/types";
import { getVOFValue } from "@cervval.js/common/src/tools/object.tools";
import { CheckboxGroupOptions, CjsCheckboxGroup } from "../../components/checkboxGroup/checkboxGroup";
import { CjsEditor, EditorOptions, defaultEditorOptions } from "../editor";

export type CheckboxGroupEditorOptions = EditorOptions;

/**
 * Checkbox group editor class
 */
@CustomElement({
    name: "cjs-checkbox-group-editor",
    style: require("./checkboxGroupEditor.scss"),
    elementCssClasses: ["cjs-editor"]
})
export class CjsCheckboxGroupEditor extends CjsEditor<UID[]> {

    /** Editor options */
    @TypedWebComponentOptions(defaultEditorOptions)
    public readonly options!: WebComponentOptions<CheckboxGroupEditorOptions>;

    /** Checkbox group of editor */
    public checkboxGroup = new CjsCheckboxGroup();

    constructor(options?: Partial<CheckboxGroupEditorOptions>, checkboxGroupOptions?: Partial<CheckboxGroupOptions>, customElementOptions?: OverrideCustomElementConfig) {
        super(customElementOptions);
        this.options.setWithoutRefresh(options);
        this.checkboxGroup.options.setWithoutRefresh(checkboxGroupOptions);
    }

    /** 
     * Get input of Editor, where user set data 
     */
    public getInput(): CjsCheckboxGroup {
        return this.checkboxGroup;
    }

    /**
     * Init editor
     */
    public override init(): void {
        super.init();

        // Append checkbox component
        this.append(this.checkboxGroup);

        // Listen to group change, dispatch value change event of editor
        this.checkboxGroup.changeEvent.on(() => this._onInputValueChange());
    }

    /** 
     * Refresh editor 
     */
    public override refresh(): void {
        this.checkboxGroup.refresh("editorRefresh", { values: this._value });
        super.refresh();
    }

    /** Set formCheckInput as validation form element */
    public override getValidationFormElement(): HTMLElement[] {
        return this.checkboxGroup.checkboxes.map(ck => ck.components.formCheckInput);
    }

    /**
     * Update the input value from stored value
     */
    protected _refreshInputValue(): void {
        this.checkboxGroup.setSelectedValues(this._value ?? []);
    }

    /**
     * Gets the value corresponding to the current input value
     */
    protected _getValueFromInputComponent(): UID[] | undefined {
        return this.checkboxGroup.getSelectedValues();
    }

    /** Update disabled attribute on input component */
    protected _refreshDisabled(): void {
        this.checkboxGroup.options.setWithoutRefresh({
            disabled: Boolean(getVOFValue(this.options.disabled))
        });
    }
}